import encodeFormData from '../../utilities/js/encodeFormData/encodeFormData.js';
import ProductPageRepository from './productPageRepository';

let service;

class ProductPage {
  constructor() {
    this.productPageRepository = new ProductPageRepository();
  }

  handleGeneralRequest(url, data, method, credentials) {
    let encodedData, thisUrl;
    if (data) {
      encodedData = encodeFormData(data);
      thisUrl = url.includes("?") ? `${url}&${encodedData}` : `${url}?${encodedData}`;
    } else {
      thisUrl = `${url}`;
    }

    return fetch(thisUrl, {
      method: method,
      credentials: credentials,
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      }
    })
      .then(response => {
        if (response.status === 200 || response.ok) {
          return response.json();
        }
      })
  }

  addToBasketWithPrintData(url, data) {
    return this.productPageRepository.addToBasketWithPrintData(url, data);
  }

  quantityChanged(data) {
    return this.productPageRepository.calculatePriceByItemId(data)
  }
}

function productPage() {
  if (service) {
    return service;
  } else {
    service = new ProductPage();
    return service;
  }
}

export default productPage;
